module.exports = __webpack_public_path__ + "img/replace.555d0cf8.svg";